﻿import { proxyTexts } from "@serenity-is/corelib";

namespace texts {

    export declare namespace Controls {

        namespace IdleTimeout {
            export const CountdownMessage: string;
            export const KeepAliveButton: string;
            export const SignoutButton: string;
            export const WarningMessage: string;
            export const WarningTitle: string;
        }
    }

    export declare namespace Db {

        namespace Pro {

            namespace DataAuditLog {

                namespace DataAuditLog {
                    export const FieldName: string;
                    export const LogDate: string;
                    export const LogId: string;
                    export const LogType: string;
                    export const NewValue: string;
                    export const OldValue: string;
                    export const RecordId: string;
                    export const Tablename: string;
                    export const UserDisplayName: string;
                    export const UserId: string;
                    export const Username: string;
                }
            }

            namespace EmailQueue {

                namespace EmailQueue {
                    export const Bcc: string;
                    export const Body: string;
                    export const Cc: string;
                    export const ErrorMessage: string;
                    export const InsertDate: string;
                    export const InsertUser: string;
                    export const InsertUserId: string;
                    export const LockExpiration: string;
                    export const MailFrom: string;
                    export const MailId: string;
                    export const MailTo: string;
                    export const Priority: string;
                    export const ReplyTo: string;
                    export const RetryCount: string;
                    export const SentDate: string;
                    export const SerializedMessage: string;
                    export const Status: string;
                    export const Subject: string;
                    export const Uid: string;
                }
            }

            namespace Extensions {

                namespace FileSystem {
                    export const Contents: string;
                    export const CreationTime: string;
                    export const Extension: string;
                    export const Filename: string;
                    export const FullPath: string;
                    export const Id: string;
                    export const IsDirectory: string;
                    export const LastWriteTime: string;
                    export const Metadata: string;
                    export const ParentPath: string;
                    export const Size: string;
                }
            }
        }
    }

    export declare namespace Forms {

        namespace Membership {

            namespace Elevation {
                export const ActionRequiresElevation: string;
                export const ConfirmAccess: string;
                export const ElevateButton: string;
                export const FormTitle: string;
                export const InvalidPassword: string;
            }
        }
    }

    export declare namespace Site {

        namespace CardViewMixin {
            export const CardView: string;
            export const ListView: string;
        }

        namespace DraggableGroupingMixin {
            export const CollapseAllButton: string;
            export const DropPlaceholder: string;
            export const ExpandAllButton: string;
        }

        namespace FavoriteViewsMixin {
            export const DeleteButtonHint: string;
            export const DeleteSuccessMessage: string;
            export const EmptyNameError: string;
            export const FavoriteViews: string;
            export const LoadedViewMessage: string;
            export const SaveButton: string;
            export const SaveSuccessMessage: string;
            export const SaveView: string;
        }

        namespace HeaderFiltersMixin {
            export const CancelButton: string;
            export const ClearButton: string;
            export const Null: string;
            export const OkButton: string;
            export const Search: string;
            export const SelectAll: string;
        }

        namespace TwoFactor {
            export const AuthenticatorOption: string;
            export const AvailableTwoFactorMethods: string;
            export const ConfigureAddButton: string;
            export const ConfigureEditButton: string;
            export const ConfiguredBadge: string;

            namespace Email {
                export const ActivateButton: string;
                export const AlreadyConfiguredWarning: string;
                export const ConfigureCodeLabel: string;
                export const ConfigureCodePrompt: string;
                export const ConfigureInvalidCode: string;
                export const ConfigureNumberPrompt: string;
                export const ConfigurePageTitle: string;
                export const ConfigurePrompt: string;
                export const ConfigureSendButton: string;
                export const ConfigureSuccess: string;
                export const DeactivateButton: string;
                export const DeactivateConfirmation: string;
                export const EmailAddress: string;
                export const EmailOption: string;
                export const InvalidEmail: string;
            }
            export const FormTitle: string;
            export const GoBackTo2FASettings: string;
            export const NotEnabledMessage: string;
            export const OutOfAllowedAttempts: string;
            export const Preferred2FAMethod: string;
            export const RecoveryCodeOption: string;

            namespace SMS {
                export const ActivateButton: string;
                export const AlreadyConfiguredWarning: string;
                export const ConfigureCodeLabel: string;
                export const ConfigureCodePrompt: string;
                export const ConfigureInvalidCode: string;
                export const ConfigureNumberPrompt: string;
                export const ConfigurePageTitle: string;
                export const ConfigurePrompt: string;
                export const ConfigureSendButton: string;
                export const ConfigureSuccess: string;
                export const DeactivateButton: string;
                export const DeactivateConfirmation: string;
                export const InvalidMobileNumber: string;
                export const MobileNumber: string;
                export const SMSOption: string;
                export const SMSReason: string;
            }
            export const SelectAnOption: string;
            export const SelectedOptionNotAvailable: string;
            export const SuccessMessage: string;
            export const UserSettingsMenuItem: string;
            export const UserSettingsPageTitle: string;
        }

        namespace WizardDialog {
            export const BackButton: string;
            export const CancelButton: string;
            export const CancelMessage: string;
            export const FinishButton: string;
            export const NextButton: string;
        }

    }

}

const Texts: typeof texts = proxyTexts({}, '', {
    Controls: {
        IdleTimeout: {}
    },
    Db: {
        Pro: {
            DataAuditLog: {
                DataAuditLog: {}
            },
            EmailQueue: {
                EmailQueue: {}
            },
            Extensions: {
                FileSystem: {}
            }
        }
    },
    Forms: {
        Membership: {
            Elevation: {}
        }
    },
    Site: {
        CardViewMixin: {},
        DraggableGroupingMixin: {},
        FavoriteViewsMixin: {},
        HeaderFiltersMixin: {},
        TwoFactor: {
            Email: {},
            SMS: {}
        },
        WizardDialog: {}
    }
}) as any;

export const CardViewMixinTexts = Texts.Site.CardViewMixin;

export const DraggableGroupingMixinTexts = Texts.Site.DraggableGroupingMixin;

export const ElevationFormTexts = Texts.Forms.Membership.Elevation;

export const EmailTwoFactorTexts = Texts.Site.TwoFactor.Email;

export const FavoriteViewsMixinTexts = Texts.Site.FavoriteViewsMixin;

export const HeaderFiltersMixinTexts = Texts.Site.HeaderFiltersMixin;

export const IdleTimeoutTexts = Texts.Controls.IdleTimeout;

export const ProExtensionsTexts = Texts;

export const SMSTwoFactorTexts = Texts.Site.TwoFactor.SMS;

export const TwoFactorTexts = Texts.Site.TwoFactor;

export const WizardDialogTexts = Texts.Site.WizardDialog;